import { Component } from '@angular/core';

@Component({
  selector: 'first-meeting-template',
  templateUrl: './first-meeting-template.component.html',
  styleUrls: ['../../../meeting-form.component.scss', '../../form-steps.scss']
})
export class FirstMeetingTemplateComponent {
  opened = false
}
